/** @jsxImportSource theme-ui */
import React from 'react';
import { Formik } from 'formik';
import { usePostUsageMutation } from '@/store/apiService';
import { toast } from 'react-toastify';
import { CreateUsageForm } from './CreateUsageForm';
import { ProductType } from '@/types/types';

type Props = {
    companyId: string;
    onSubmitSuccess?: () => void;
};

const CreateUsage: React.FC<Props> = ({ companyId, onSubmitSuccess = () => {} }: Props) => {
    const [createUsage, createUsageState] = usePostUsageMutation();

    const initialValues = {
        _articleType: ProductType.Usage,
        _articleGroup: '',
        ArticleNumber: '',
        Quantity: 1,
        Description: '',
        Date: null as string | null,
        CompanyId: companyId,
    };

    return (
        <>
            <Formik
                initialValues={initialValues}
                enableReinitialize
                onSubmit={(values, { resetForm, setErrors, setSubmitting }) => {
                    createUsage(values)
                        .unwrap()
                        .then((res) => {
                            onSubmitSuccess();
                        })
                        .catch((err) => {
                            setSubmitting(false);
                            toast.error(err.data, { autoClose: 5000 });
                        });
                }}
            >
                {(formProps) => {
                    return (
                        <>
                            <CreateUsageForm
                                additionalErrors={createUsageState.error}
                                {...formProps}
                            />
                        </>
                    );
                }}
            </Formik>
        </>
    );
};

export default CreateUsage;
